import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SellerShellPjComponent } from './seller-shell-pj/seller-shell-pj.component';

const routes: Routes = [
  {
    path: 'seller-info-pj',
    component: SellerShellPjComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [Location],
  exports: [RouterModule],
})
export class SellerPjRoutingModule {}
